import React from 'react';
import { InvoiceStatus } from '../../../@types';
import { Statuses } from '../../../constants';

 
  export const getStatusClass = (status: InvoiceStatus) => {
    switch (status) {
      case Statuses.PAID:
        return 'text-[#088306] shadow-md hover:shadow-md cursor-pointer rounded-md text-[16px] w-[53px]';
      case Statuses.PENDING:
        return 'text-[#FF6702] shadow-md hover:shadow-md cursor-pointer rounded-md text-[16px] w-[80px]';
      case Statuses.DRAFT:
        return 'text-[#4E4E4E] shadow-md hover:shadow-md cursor-pointer rounded-md text-[16px] w-[59px]';
      case Statuses.DUE:
        return 'text-[#FB0303] shadow-md hover:shadow-md cursor-pointer rounded-md text-[16px] w-[53px]';
      case Statuses.CANCELLED:
        return 'text-[#101010] shadow-md hover:shadow-md cursor-pointer rounded-md text-[16px] w-[89px] ';
        case Statuses.REFUNDED:
        return 'text-[#044E97] shadow-md hover:shadow-md cursor-pointer rounded-md text-[16px] w-[84px]';
      default:
        return '';
    }
}
    

 export const getStatusColor = (status: InvoiceStatus) => {
    switch (status) {
      case Statuses.PAID:
        return '#B5CDB4';
      case Statuses.PENDING:
        return '#E6C8B3';
      case Statuses.DRAFT:
        return '#C5C5C5';
      case Statuses.DUE:
        return '#E5B4B4';
      case Statuses.CANCELLED:
        return '#7D7D7D';
        case Statuses.REFUNDED:
          return '#C9EBF3';
      default:
        return '';
    }
  };
  export const customTextColors = {
    paid: '#088306',
    pending: '#FF6702',
    draft: '#4E4E4E',
    overdue: '#FB0303',
    cancelled: '#101010',
    refunded: '#044E97',
  };

  export const customColors = {
    paid: '#B5CDB4',
    pending: '#E6C8B3',
    draft: '#C5C5C5',
    overdue: '#E5B4B4',
    cancelled: '#7D7D7D',
    refunded: '#C9EBF3',
  };




